import { IDENTITY_DOCUMENT_FORMAT_MESSAGE, isValidIdentityDocument } from "./identityDocument";

/**
 * @param {object} fields
 * @returns {string | null} error message or null if valid
 */
export function validateStaffRegistrationForm(fields) {
  const {
    dni,
    nombre,
    primerApellido,
    telefono,
    email,
    rol,
    contraseña,
    contraseñaConfirmacion,
    cursoIds,
  } = fields;

  if (!rol || String(rol).trim() === "") {
    return "Selecciona un rol.";
  }
  if (!isValidIdentityDocument(dni)) {
    return IDENTITY_DOCUMENT_FORMAT_MESSAGE;
  }
  if (!String(nombre || "").trim()) {
    return "El nombre es obligatorio.";
  }
  if (!String(primerApellido || "").trim()) {
    return "El primer apellido es obligatorio.";
  }
  if (!String(telefono || "").trim()) {
    return "El teléfono es obligatorio.";
  }
  if (!String(email || "").trim()) {
    return "El email es obligatorio.";
  }
  const emailNorm = String(email).trim();
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailNorm)) {
    return "El email no es válido.";
  }
  const pwd = String(contraseña || "").trim();
  const pwdConfirm = String(contraseñaConfirmacion || "").trim();
  const isStaff = rol === "director" || rol === "instructor";
  if (isStaff) {
    if (!pwd || pwd.length < 8) {
      return "La contraseña es obligatoria (mínimo 8 caracteres).";
    }
    if (pwd !== pwdConfirm) {
      return "La contraseña y la confirmación no coinciden.";
    }
  } else {
    if (pwdConfirm !== "" && pwd === "") {
      return "Introduce la contraseña para confirmarla.";
    }
    if (pwd !== "" && pwd !== pwdConfirm) {
      return "La contraseña y la confirmación no coinciden.";
    }
  }
  if (rol === "instructor" && (!Array.isArray(cursoIds) || cursoIds.length === 0)) {
    return "Selecciona al menos un curso para el instructor.";
  }
  if (rol === "alumno" && (!Array.isArray(cursoIds) || cursoIds.length === 0)) {
    return "Selecciona al menos un curso para el alumno.";
  }
  return null;
}
